import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Icon from '@material-ui/core/Icon';
// import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
// import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
// import Divider from '@material-ui/core/Divider';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Option, Scope, Select as InformedSelect } from 'informed';
import { Cell, Grid } from 'react-md';
import { withStyles } from '@material-ui/core/styles';
import { compact, defaultTo, get } from 'lodash-es';

import CurrencyField from '../../Common/CurrencyField';
import CurrencyFieldMU from '../../Common/CurrencyFieldMU';
import HiddenField from '../../Common/HiddenField';
import NumberField from '../../Common/NumberField';
import PercentField from '../../Common/PercentField';
import Select from '../../Common/Select';
import TextField from '../../Common/TextField';
// import Lender from './Lender';
import LenderSelect from './LenderSelect';
import Summary from './Summary';

import './LoanBlock.scss';

class LoanBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loans: [{ id: -1, increments: [{}] }],
      selectedValue: '',
      expanded: true,
      lenderId: undefined,
    };
  }

  static componentDidMount() {
    const { expanded } = this.props;
    this.setState({
      expanded,
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { values, expanded } = nextProps;
    const { loans } = prevState;
    let newState = null;
    if (Array.isArray(values.loan) && values.loan.length > 0 && loans.length > 0 && loans[0].id === -1) {
      newState = {
        loans: values.loan.map(l => ({
          id: Math.random(),
          increments: Array.isArray(l.increments)
            ? l.increments.map(() => ({
                id: Math.random(),
              }))
            : [{ id: Math.random() }],
        })),
      };
    }
    if (expanded !== prevState.expanded) {
      newState = newState ? Object.assign(newState, { expanded }) : { expanded };
    }
    return newState;
  }

  componentDidUpdate(prevProps, prevState) {
    const { loans } = this.state;
    if (prevState.loans !== loans) {
      this.deepCleanValues();
    }
  }

  // workaround for informed issue: https://github.com/joepuzzo/informed/issues/8
  deepCleanValues = (property = 'loan') => {
    const { formApi } = this.props;
    const propertyState = defaultTo(formApi.getValue(property), []);

    const cleanPropertyState = compact(propertyState).map(loan =>
      Object.assign(
        loan,
        (Array.isArray(loan.increments) && loan.increments.length) > 0
          ? { increments: compact(loan.increments) }
          : undefined
      )
    );

    formApi.setValues({ ...formApi.getState().values, [property]: cleanPropertyState });
  };

  addLoan = () => {
    this.setState(prevState => {
      if (prevState.loans.length > 0) {
        return {
          loans: [...prevState.loans, { id: Math.random(), increments: [{ id: Math.random() }] }],
        };
      }
      return {
        loans: [...prevState.loans, { id: -1, increments: [{ id: Math.random() }] }],
      };
    });
    this.deepCleanValues();
  };

  removeLoan = i => {
    this.setState(prevState => {
      const loans = [...prevState.loans];
      loans.splice(i, 1);
      return {
        loans,
      };
    });
    this.deepCleanValues();
  };

  addIncrement = i => {
    this.setState(prevState => {
      const loans = [...prevState.loans];
      loans[i].increments = [...loans[i].increments, { id: Math.random(), payment_frequency: 'month' }];
      return {
        loans,
      };
    });
  };

  removeIncrement = (i, j) => {
    this.setState(prevState => {
      const loans = [...prevState.loans];
      loans[i].increments.splice(j, 1);
      return {
        loans,
      };
    });
  };

  render() {
    const { expanded, selectedValue, loans, lenderId } = this.state;
    const { actions, formApi, onSave, strings, classes, config, values, setExpanded, readOnly, releaseDate } =
      this.props;

    // eslint-disable-next-line no-unused-vars
    const handleSave = value => {
      this.setState({
        selectedValue: value,
      });
      onSave(formApi.getState().values);
    };

    const toggleExpanded = () => {
      setExpanded('loan', !expanded);
    };

    const getSummary = () => {
      const { loan } = formApi.getState().values;
      return (
        <Summary
          durationUnitOptions={config.loan.duration_unit.options}
          kindOptions={config.loan.kind.options}
          loans={loan}
          strings={strings}
          readOnly={readOnly}
        />
      );
    };

    const lenderAddressesOptions = i =>
      get(values, `loan[${i}].lender`)
        ? get(config, `loan.lenderAddresses.options[[${get(values, `loan[${i}].lender`)}]`)
        : [];

    const validate = value => {
      if (value === 0) return null;
      return !value || value.toString().trim() === ''
        ? get(strings, 'validation.field.required', 'This field is a required field')
        : null;
    };

    const loanList = () => (
      <Fragment key="loan-form">
        {loans.map((loan, i) => (
          <div key={`loan-field-${loan.id}`} className="loans item">
            <Scope scope={`loan[${i}]`}>
              <Grid className="grid-1">
                <Cell size={5}>
                  <Select
                    className="select"
                    key={`kind-${loan.id}`}
                    field="kind"
                    id={`kind-${loan.id}`}
                    name="kind"
                    shrink
                    label={get(strings, 'block.loan.field.kind.label')}
                    placeholder=""
                    options={get(config, 'loan.kind.options')}
                    required
                    onChange={value => this.setState({ selectedValue: value })}
                    validate={validate}
                    validateOnChange
                    validateOnBlur
                    disabled={readOnly}
                  />
                  <HiddenField field="release_date" initialValue={releaseDate} />
                </Cell>
                <Cell size={5}>
                  <CurrencyFieldMU
                    key={`amount-${loan.id}`}
                    field="amount"
                    id={`amount-${loan.id}`}
                    name="amount"
                    label={get(strings, 'block.loan.field.amount.label')}
                    placeholder=""
                    required
                    shrink
                    onChange={value => this.setState({ selectedValue: value })}
                    value={selectedValue}
                    validate={validate}
                    validateOnChange
                    validateOnBlur
                    disabled={readOnly}
                  />
                </Cell>
                <Cell size={2}>
                  {!values.loan ||
                  (values.loan && values.loan[i] && values.loan[i].kind && values.loan[i].kind !== 'interest_free') ? (
                    <PercentField
                      key={`rate-${loan.id}`}
                      field="rate"
                      id={`rate-${loan.id}`}
                      name="rate"
                      label={strings['block.loan.field.rate.label']}
                      placeholder=""
                      required
                      shrink
                      validate={validate}
                      validateOnChange
                      validateOnBlur
                      disabled={readOnly}
                    />
                  ) : (
                    ''
                  )}
                </Cell>
              </Grid>
              <Grid className="grid-2">
                <Cell size={4}>
                  <TextField
                    type="number"
                    className="textfield"
                    key={`duration-${loan.id}`}
                    field="duration"
                    id={`duration-${loan.id}`}
                    name="duration"
                    shrink
                    label={strings['block.loan.field.duration.label']}
                    placeholder=""
                    required
                    onChange={value => this.setState({ selectedValue: value })}
                    value={selectedValue}
                    validate={validate}
                    validateOnChange
                    validateOnBlur
                    disabled={readOnly}
                  />
                </Cell>
                <Cell size={4}>
                  <Select
                    className="select"
                    key={`duration_unit-${loan.id}`}
                    field="duration_unit"
                    id={`duration_unit-${loan.id}`}
                    name="duration_unit"
                    shrink
                    label={strings['block.loan.field.duration_unit.label']}
                    placeholder=""
                    options={config.loan.duration_unit.options}
                    required
                    onChange={value => this.setState({ selectedValue: value })}
                    value={selectedValue}
                    initialValue={
                      values && values.loan[i] && values.loan[i].duration_unit
                        ? values.loan[i].duration_unit
                        : config.loan.duration_unit.initialValue
                    }
                    validate={validate}
                    validateOnChange
                    validateOnBlur
                    disabled={readOnly}
                  />
                </Cell>
                <Cell size={4}>
                  <Select
                    className="select"
                    key={`payment_frequency-${loan.id}`}
                    field="payment_frequency"
                    id={`payment_frequency-${loan.id}`}
                    name="payment_frequency"
                    shrink
                    label={strings['block.loan.field.payment_frequency.label']}
                    placeholder=""
                    options={config.loan.payment_frequency.options}
                    required
                    onChange={value => this.setState({ selectedValue: value })}
                    value={selectedValue}
                    initialValue={
                      values && values.loan[i] && values.loan[i].payment_frequency
                        ? values.loan[i].payment_frequency
                        : config.loan.payment_frequency.initialValue
                    }
                    validate={validate}
                    validateOnChange
                    validateOnBlur
                    disabled={readOnly}
                  />
                </Cell>
              </Grid>
              {/* DEFERRAL */}
              {get(values, `loan[${i}].kind`) !== 'interest_free' ? (
                <Grid className="grid-4">
                  <Cell size={6}>
                    <Select
                      className="select"
                      key={`deferral-${loan.id}`}
                      field="deferral"
                      id={`deferral-${loan.id}`}
                      name="deferral"
                      shrink
                      label={strings['block.loan.field.deferral.label']}
                      placeholder=""
                      options={get(config, 'loan.deferral.options')}
                      onChange={value => this.setState({ selectedValue: value })}
                      value={selectedValue}
                      disabled={readOnly}
                    />
                  </Cell>
                  {/* DEFERRAL DURATION */}
                  {get(values, `loan[${i}].deferral`) === 'fully' ||
                  get(values, `loan[${i}].deferral`) === 'partially' ? (
                    <Cell size={6}>
                      <TextField
                        className="textfield"
                        type="number"
                        key={`deferral_duration-${loan.id}`}
                        field="deferral_duration"
                        id={`deferral_duration-${loan.id}`}
                        name="deferral_duration"
                        shrink
                        label={strings['block.loan.field.deferral_duration.label']}
                        placeholder=""
                        required
                        onChange={value => this.setState({ selectedValue: value })}
                        value={selectedValue}
                        validate={validate}
                        validateOnChange
                        validateOnBlur
                        disabled={readOnly}
                      />
                    </Cell>
                  ) : (
                    ''
                  )}
                </Grid>
              ) : (
                ''
              )}
              {/* LENDER */}
              <Grid className="grid-3 lender-block">
                <Cell size={5} className="lender">
                  <LenderSelect
                    key={`lender-${loan.id}`}
                    field="lender"
                    id={`lender-${loan.id}`}
                    name="lender"
                    label={strings['block.loan.field.lender.label']}
                    placeholder=""
                    required={false}
                    onChange={value => this.setState({ selectedValue: value, lenderId: value })}
                    value={selectedValue}
                    options={config.loan.lenders.options}
                    fetchLenderAddresses={actions.fetchLenderAddresses}
                    fetchLenders={actions.fetchLenders}
                    type="lenders"
                    style={{
                      minWith: '200px',
                    }}
                    validate={validate}
                    validateOnChange
                    validateOnBlur
                    disabled={readOnly}
                  />
                </Cell>
                {/* LENDER ADDRESS */}
                <Cell size={7} className="lender-address">
                  <LenderSelect
                    key={`lender_address-${loan.id}`}
                    field="lender_address"
                    id={`lender_address-${loan.id}`}
                    name="lender_address"
                    label={strings['block.loan.field.lender_address.label']}
                    placeholder=""
                    required={false}
                    onChange={value => this.setState({ selectedValue: value })}
                    value={selectedValue}
                    options={lenderAddressesOptions(i)}
                    fetchLenders={actions.fetchLenders}
                    fetchLenderAddresses={actions.fetchLenderAddresses}
                    type="lenderAddresses"
                    lenderId={lenderId}
                    style={{
                      minWith: '250px',
                    }}
                    validate={validate}
                    validateOnChange
                    validateOnBlur
                    disabled={readOnly}
                  />
                </Cell>
              </Grid>
              {/* INCREMENTS */}
              {values.loan && values.loan[i] && values.loan[i].kind && values.loan[i].kind === 'graduated' ? (
                <Grid className="grid-5">
                  <div
                    style={{
                      backgroundColor: '#fafafa',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyItems: 'stretch',
                      alignItems: 'flex-end',
                      border: '1px solid #dadada',
                      position: 'relative',
                      paddingTop: '12px',
                    }}
                  >
                    <div className="title">{strings['block.loan.increments.title']}</div>
                    {loans[i].increments.map((increment, j) => (
                      <div
                        key={`increments-field-${increment.id}`}
                        style={{
                          backgroundColor: '#fafafa',
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyItems: 'stretch',
                          alignItems: 'flex-end',
                          borderBottom: '1px solid #dadada',
                          flexWrap: 'wrap',
                          position: 'relative',
                        }}
                        className="increments"
                      >
                        <Scope scope={`increments[${j}]`}>
                          <div
                            style={{
                              flexGrow: 0,
                              display: 'flex',
                              flexDirection: 'column',
                              padding: '7px 5px',
                            }}
                          >
                            #{j + 1}
                          </div>
                          <div
                            style={{
                              flexGrow: 1,
                              display: 'flex',
                              flexDirection: 'column',
                              padding: '7px 5px',
                            }}
                          >
                            <label htmlFor="payment_amount" className="label">
                              {strings['block.loan.field.increments.payment_amount.label']}
                              {' *'}
                            </label>
                            <CurrencyField
                              name="payment_amount"
                              label={strings['block.loan.field.number_of_payments.label']}
                              required
                              onChange={value => this.setState({ selectedValue: value })}
                              field="payment_amount"
                              id="payment_amount"
                              validate={validate}
                              validateOnChange
                              validateOnBlur
                              disabled={readOnly}
                            />
                            {/* <Text type="number" field="payment_amount" id="payment_amount" /> */}
                          </div>
                          <div
                            style={{
                              flexGrow: 1,
                              display: 'flex',
                              flexDirection: 'column',
                              padding: '7px 5px',
                            }}
                          >
                            <label htmlFor="number_of_payments" className="label">
                              {strings['block.loan.field.increments.number_of_payments.label']}
                              {' *'}
                            </label>
                            <NumberField
                              field="number_of_payments"
                              id="number_of_payments"
                              validate={validate}
                              validateOnChange
                              validateOnBlur
                              disabled={readOnly}
                            />
                          </div>
                          <div
                            style={{
                              flexGrow: 1,
                              display: 'flex',
                              flexDirection: 'column',
                              padding: '7px 5px',
                            }}
                          >
                            <label htmlFor="payment_frequency" className="label">
                              {strings['block.loan.field.increments.payment_frequency.label']}
                              {' *'}
                            </label>
                            <InformedSelect
                              field="payment_frequency"
                              id="payment_frequency"
                              initialValue={
                                values &&
                                values.loan[i] &&
                                values.loan[i].increments &&
                                values.loan[i].increments[j] &&
                                values.loan[i].increments[j].payment_frequency
                                  ? values.loan[i].increments[j].payment_frequency
                                  : 'month'
                              }
                              className="informed-select"
                              validate={validate}
                              validateOnChange
                              validateOnBlur
                              disabled={readOnly}
                            >
                              <Option value="month">Mois</Option>
                              <Option value="year">Année</Option>
                            </InformedSelect>
                          </div>
                          <div
                            style={{
                              flexGrow: 0,
                              padding: '0',
                            }}
                          >
                            <Tooltip
                              disableHoverListener={
                                loans[i].increments.length <= 1 || loans[i].increments.length > j + 1
                              }
                              title={strings['block.loan.btn.increments.remove.label']}
                              placement="left"
                            >
                              <div
                                style={{
                                  padding: '0',
                                  margin: '8px',
                                }}
                                className="actions-remove-increments"
                              >
                                <Button
                                  type="button"
                                  onClick={() => this.removeIncrement(i, j)}
                                  size="small"
                                  color="secondary"
                                  className={classes.button}
                                  // variant="outlined"
                                  disabled={
                                    loans[i].increments.length <= 1 || loans[i].increments.length > j + 1 || readOnly
                                  }
                                  style={{
                                    margin: '0',
                                  }}
                                >
                                  <Icon className={classes.icon}>remove_circle_outline</Icon>
                                </Button>
                              </div>
                            </Tooltip>
                          </div>
                        </Scope>
                      </div>
                    ))}
                    <div
                      style={{
                        padding: '0',
                      }}
                      className="actions-add-increments"
                    >
                      <Tooltip title={strings['block.loan.btn.increments.add.label']} placement="left">
                        <Button
                          type="button"
                          onClick={() => this.addIncrement(i)}
                          size="small"
                          color="primary"
                          className={classes.button}
                          disabled={readOnly}
                        >
                          <Icon className={classes.icon}>add_circle_outline</Icon>
                        </Button>
                      </Tooltip>
                    </div>
                  </div>
                </Grid>
              ) : (
                ''
              )}
              {/* <label htmlFor={`amount-${i}`}>amount {i}:</label>
          <Text field="amount" id={`amount-${i}`} key={`amount-${loan.id}`} /> */}
            </Scope>
            {/* <button type="button" onClick={() => this.removeLoan(i)}>
              {strings['block.loan.btn.remove.label']}
            </button> */}
            <div className="title--sub-block">{`${strings['block.loan.subtitle']} Nº${i + 1}`}</div>
            <Tooltip
              disableHoverListener={loans.length <= 1 || loans.length > i + 1}
              title={strings['block.loan.btn.remove.label']}
              placement="left"
            >
              <div
                style={{
                  position: 'absolute',
                  top: '-21px',
                  right: '10px',
                }}
              >
                <Button
                  type="button"
                  onClick={() => this.removeLoan(i)}
                  // size="small"
                  color="secondary"
                  className={`remove-loan-button ${classes.button}`}
                  variant="fab"
                  disabled={loans.length <= 1 || loans.length > i + 1 || readOnly}
                  aria-label={strings['block.loan.btn.remove.label']}
                  style={{
                    width: '40px',
                    height: '40px',
                    margin: '0',
                  }}
                >
                  <Icon className={classes.icon}>remove</Icon>
                </Button>
              </div>
            </Tooltip>
          </div>
        ))}
      </Fragment>
    );

    return (
      <ExpansionPanel
        className={`expansion-panel ${expanded ? 'expanded' : ''}`}
        expanded={expanded}
        onChange={toggleExpanded}
      >
        <ExpansionPanelSummary
          className="expansion-panel-summary"
          expandIcon={<ExpandMoreIcon className="expansion-more-icon" />}
        >
          <span className="block-title">
            <Typography className="title">{strings['block.loan.title']}</Typography>
            <Typography className="chip">{values.loan.length}</Typography>
          </span>
          {expanded ? '' : <div className="summary">{getSummary()}</div>}
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.details}>
          <div className="loans details">
            <div className="loans list">{loanList()}</div>
            <div className="loans actions">
              <Tooltip title={strings['block.loan.btn.add.label']} placement="right">
                <Button
                  type="button"
                  onClick={() => this.addLoan()}
                  // size="small"
                  color="primary"
                  className={`add-loan-button ${classes.button}`}
                  variant="fab"
                  aria-label={strings['block.loan.btn.add.label']}
                  style={{
                    width: '40px',
                    height: '40px',
                    margin: '0',
                  }}
                  disabled={readOnly}
                >
                  <Icon className={classes.icon}>add</Icon>
                </Button>
              </Tooltip>
            </div>
          </div>
        </ExpansionPanelDetails>
        {/* <Divider />
        <ExpansionPanelActions>
          <Button type="submit" size="small" color="primary" onClick={handleSave}>
            {strings['block.btn.save.label']}
          </Button>
        </ExpansionPanelActions> */}
      </ExpansionPanel>
    );
  }
}

LoanBlock.propTypes = {
  formApi: PropTypes.any.isRequired, // eslint-disable-line
  data: PropTypes.any.isRequired, // eslint-disable-line
  onSave: PropTypes.func.isRequired, // eslint-disable-line
  strings: PropTypes.object.isRequired, // eslint-disable-line
  classes: PropTypes.any.isRequired, // eslint-disable-line
  config: PropTypes.any.isRequired, // eslint-disable-line
  values: PropTypes.any.isRequired, // eslint-disable-line
  actions: PropTypes.shape({
    fetchLenders: PropTypes.func,
    fetchLenderAddresses: PropTypes.func,
  }).isRequired,
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  releaseDate: PropTypes.string.isRequired,
};

LoanBlock.defaultProps = {};

const styles = theme => ({
  root: {},
  formControl: {},
  selectEmpty: {},
  button: {},
  input: {},
  details: {
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
    },
  },
});

export default withStyles(styles)(LoanBlock);
